import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("br_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("br_cart", JSON.stringify(items)); }, [items]);

  const add = useCallback((p) => {
    setItems((prev) => (prev.find((x) => x.id === p.id) ? prev : [...prev, p]));
    setOpen(true);
  }, []);
  const remove = useCallback((id) => setItems((prev) => prev.filter((x) => x.id !== id)), []);
  const clear = useCallback(() => setItems([]), []);
  const has = useCallback((id) => items.some((x) => x.id === id), [items]);
  const total = useMemo(() => items.reduce((a, b) => a + b.price, 0), [items]);

  return <CartCtx.Provider value={{ items, add, remove, clear, has, total, open, setOpen }}>{children}</CartCtx.Provider>;
}
